import { VariableType } from 'json-to-graphql-query';

import { DocumentPack } from '@/interfaces/documentPack';
import { EntityResource } from './entity.resource';

/**
 * Resource paczek dokumentów
 *
 * @export
 * @class DocumentPackResource
 * @extends {EntityResource<DocumentPack>}
 */
export class DocumentPackResource extends EntityResource<DocumentPack> {
  public getFields = {
    id: true,
    name: true,
    procedureId: true
  };

  public listFields = {
    id: true,
    name: true,
    number: true,
    status: true,
    systemNumbers: true,
    structureNode: {
      id: true,
      name: true
    }
  };

  public listVariables = { filters: 'DocumentPackFilters' };

  constructor() {
    super({
      entityName: 'documentPack'
    });
  }

  public receive(variables: { id: number; packMdokId: number }): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!', packMdokId: 'Int!' },
        documentPackReceive: {
          __args: { id: new VariableType('id'), packMdokId: new VariableType('packMdokId') }
        }
      }
    });
    return this.mutation({ mutation, variables }, 'documentPackReceive');
  }
}

export const documentPackResource = new DocumentPackResource();
